import React, { useContext } from "react";
import { Row, Col, Form, FormGroup, FormLabel } from "react-bootstrap";
import Select from "react-select";
import SweetAlert from "react-bootstrap-sweetalert";
import { useWizard } from "./WizardContext";
import { useGuestContext } from "../../../../contexts/GuestContext";
import LanguageToggle from "../LanguageToggle";
import cuteMonk1 from "../../../../assets/img/baolinPrivate/cute_monk1.png";
import cuteMonk2 from "../../../../assets/img/baolinPrivate/cute_monk2.png";

const Step2 = React.forwardRef((props, ref) => {
  const {
    attendanceType, setAttendanceType,
    mothersDayFlowers, setMothersDayFlowers,
    relatives, setRelatives,
  } = useWizard();

  const { language } = useGuestContext();

  const [relativesError, setRelativesError] = React.useState(null);
  const [alertState, setAlertState] = React.useState(null);

  const relativesOptions = Array.from({ length: 15 }, (_, i) => ({
    value: i + 1,
    label: `${i + 1}`,
  }));

  const handleRelativesChange = (option) => {
    setRelatives(option.value);
    setRelativesError(null);
    setAlertState(
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={language === "English" ? "Reminder" : "提醒"}
        onConfirm={() => setAlertState(null)}
        confirmBtnBsStyle="success"
        confirmBtnText={language === "English" ? "I Understand" : "我明白了"}
      >
        <strong>
          {language === "English"
            ? "Please make sure the total size of your group should also include yourself."
            : "参加总人数也包括您自己本人"
          }
        </strong>
      </SweetAlert>
    );
  };

  const isValidated = () => {
    if (relatives === null || relatives === undefined) {
      setRelativesError(
        <small className="text-danger">{language === "English" ? "Please select group size." : "請選擇隨行人數"}</small>
      );
      return false;
    }
    setRelativesError(null);
    return true;
  };

  React.useImperativeHandle(ref, () => ({
    isValidated: () => {
      return isValidated();
    },
  }));

  return (
    <>
      {alertState}
      <div className="wizard-step" ref={ref}>
        <p className="text-center mb-2 font-weight-bold">
          <img src={cuteMonk1} alt="Company Logo" width="40" className="mr-3" />
          {language === "English" ? "Event Information" : "請提供以下法會相關信息"}
          <img src={cuteMonk2} alt="Company Logo" width="40" className="ml-3" />
        </p>
        <hr />
        <LanguageToggle/>
        <hr />

        {/* Group Size (Relatives) */}
        <Row className="mb-4">
          <Col md={{ span: 10, offset: 1 }}>
            <FormGroup>
              <FormLabel className="font-weight-bold">
                {language === "English" ? "Group Size (People Coming Along and yourself)" : "隨行人数（包括自己）"} <span className="text-danger">*</span>
              </FormLabel>
              <Select
                className="react-select primary"
                classNamePrefix="react-select"
                name="relativesSelect"
                value={relativesOptions.find((option) => option.value === relatives)}
                onChange={handleRelativesChange}
                options={relativesOptions}
                placeholder={language === "English" ? "Select number" : "选择人数"}
              />
              {relativesError}
            </FormGroup>
          </Col>
        </Row>
        
        {/* Attendance Type */}
        <Row className="mb-4">
          <Col md={{ span: 10, offset: 1 }}>
            <span className="description font-weight-bold d-block mb-3">
              {language === "English" ? "Please select your attendance:" : "請選擇您的参加时段:"}
            </span>
            <Form.Group>
              <div className="mb-2">
                <Form.Check
                  type="radio"
                  id="attendance-all-day"
                  label={language === "English" ? "Attend All Day" : "全天参加"}
                  checked={attendanceType === 'all_day'}
                  onChange={() => setAttendanceType('all_day')}
                  custom
                />
              </div>
              <div className="mb-2">
                <Form.Check
                  type="radio"
                  id="attendance-morning"
                  label={language === "English" ? "Attend Morning Ceremony" : "参加上午法会"}
                  checked={attendanceType === 'morning'}
                  onChange={() => setAttendanceType('morning')}
                  custom
                />
              </div>
              <div className="mb-2">
                <Form.Check
                  type="radio"
                  id="attendance-afternoon"
                  label={language === "English" ? "Attend Afternoon Buddha Bathing Only" : "只参加下午随喜浴佛"}
                  checked={attendanceType === 'afternoon'}
                  onChange={() => setAttendanceType('afternoon')}
                  custom
                />
              </div>
            </Form.Group>
          </Col>
        </Row>

        {/* Mother's Day Flowers */}
        <Row className="mb-3">
          <Col md={{ span: 10, offset: 1 }} className="d-flex align-items-center justify-content-between">
            <span className="description font-weight-bold">
              {language === "English" ? "Participate in Mother's Day gratitude flowers?" : "法會中將有母親節感恩獻花，請問是否參加？"}
            </span>
            <div className="d-flex align-items-center justify-content-end mb-2">
              <label className="mb-0">
                <span className={`mr-2 mt-1 ${mothersDayFlowers ? "text-success" : ""}`}>
                  {language === "English" ? (mothersDayFlowers ? "Yes" : "No") : (mothersDayFlowers ? "是" : "否")}
                </span>
              </label>
              <Form.Check
                type="switch"
                checked={mothersDayFlowers}
                id="mothersDayFlowers"
                onChange={(e) => setMothersDayFlowers(e.target.checked)}
              />
            </div>
          </Col>
        </Row>
        
      </div >
    </>
  );
});

export default Step2;
